import SvgIcon from '@mui/material/SvgIcon'
import React from 'react'

import { IconProps } from './types'

const CallIcon: React.FC<IconProps> = (props = {}) => {
  const { color, fontSize, style, ...rest } = props

  return (
    <SvgIcon viewBox="0 0 24 24" style={{ color, fontSize, ...style }} {...rest}>
      <path d="M18.85,20.76a13.59,13.59,0,0,1-5.62-1.24A16.84,16.84,0,0,1,8.18,16,16.84,16.84,0,0,1,4.67,11,13.63,13.63,0,0,1,3.43,5.34a.93.93,0,0,1,.27-.68.9.9,0,0,1,.68-.28H8.07a.89.89,0,0,1,.57.22.83.83,0,0,1,.29.51L9.52,8.3a1.51,1.51,0,0,1,0,.61.89.89,0,0,1-.25.43L7,11.57A11.87,11.87,0,0,0,8.13,13.2,14.83,14.83,0,0,0,9.5,14.71,15.24,15.24,0,0,0,11,16a14.21,14.21,0,0,0,1.64,1.1L14.76,15a1.19,1.19,0,0,1,.53-.3,1.46,1.46,0,0,1,.65-.06l3.14.64a1.06,1.06,0,0,1,.52.33.77.77,0,0,1,.21.53v3.69a.94.94,0,0,1-1,1ZM6.18,9.84l1.5-1.5L7.3,6.2h-2c.08.63.18,1.24.32,1.85A10.13,10.13,0,0,0,6.18,9.84ZM14.32,18a12.43,12.43,0,0,0,1.81.61,11.81,11.81,0,0,0,1.86.3v-2l-2.14-.43Z" />{' '}
    </SvgIcon>
  )
}
export default CallIcon
